import { workflowComponent } from '@banking/ui/services/debit-card-activation-modal';
import { userChangeExpiryDateAction, userChangeCvcAction, userClickVerifyCardDetailsAction } from '@banking/ui/workflows/debit-card-activation';
import { hbs } from 'ember-cli-htmlbars';
const template = hbs`
  <Banking::Checking::CardSettings::CardActivation::Details
    @expiryDateValue={{this.expiryDateValue}}
    @cvcValue={{this.cvcValue}}
    @expiryDateErrorMessage={{this.expiryDateErrorMessage}}
    @cvcErrorMessage={{this.cvcErrorMessage}}
    @detailsErrorMessage={{this.detailsErrorMessage}}
    @isLoading={{this.isLoading}}
    @onExpiryDateChange={{this.onExpiryDateChange}}
    @onCvcChange={{this.onCvcChange}}
    @verifyCardDetails={{this.verifyCardDetails}}
  />`;
const mapStateToProps = state => ({
  cvcErrorMessage: state.cvcErrorMessage || null,
  cvcValue: state.cvcValue,
  expiryDateErrorMessage: state.expiryDateErrorMessage || null,
  expiryDateValue: state.expiryDateValue,
  detailsErrorMessage: state.detailsErrorMessage || null,
  isLoading: state.isLoading
});
const mapActionsToProps = () => ({
  onCvcChange: userChangeCvcAction,
  onExpiryDateChange: userChangeExpiryDateAction,
  verifyCardDetails: userClickVerifyCardDetailsAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);